import type { ConstValues } from '@openx/types/helpers';

export const ViewOptions = {
  MAIN: 'main',
  DETAILS: 'details',
} as const;

export type ViewOptions = ConstValues<typeof ViewOptions>;
